import React from 'react'
import classNames from 'classnames'

export default ({ children, className, linkClass, text = 'Skapad av ' }) => {
  const classes = classNames('heimr-created-by', className)
  const linkClasses = classNames(
    'heimr-created-by__link',
    'heimr-created-by__link--accodeing',
    linkClass
  )

  return (
    <div className={classes}>
      {text}
      {children}
      <a href='https://accodeing.com/hosting' className={linkClasses}>
        Accodeing to you
      </a>
    </div>
  )
}
